import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import Portfolio from "./pages/Portfolio";
import Lebenslauf from "./pages/Lebenslauf";
import QuickCook from "./pages/QuickCook";
import Nordica from "./pages/Nordica";
import Phoenix from "./pages/Phoenix";
import Presentations from "./pages/Presentations";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/lebenslauf" element={<Lebenslauf />} />
          <Route path="/portfolio/quickcook" element={<QuickCook />} />
          <Route path="/portfolio/nordica" element={<Nordica />} />
          <Route path="/portfolio/phoenix" element={<Phoenix />} />
          <Route path="/portfolio/presentations" element={<Presentations />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
